var legacyViewport = 'fx_e395032e_2datsy0';

export { legacyViewport };
//# sourceMappingURL=legacyScrollArea.vanilla.mjs.map
